import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectRollsLeft, selectIsMyTurn, rollDice, acceptRoll, endTurn, selectHasRolledYet, selectMyPlayer } from '../../redux/gameSlice';
import { selectIsRollingDice, selectCurrentAnimation } from '../../redux/animationSlice';
import { Trans } from '@lingui/macro';

export default function ActionButtons(props) {
  const hasRolledYet = useSelector(selectHasRolledYet);
  const isRolling = useSelector(selectIsRollingDice);
  const isMyTurn = useSelector(selectIsMyTurn);
  const myPlayer = useSelector(selectMyPlayer);
  const rollsLeft = useSelector(selectRollsLeft);
  const anyDicePicked = useSelector((state) => state.game.rollDiceAtPos.some((rollThisDice) => rollThisDice === true));
  const curAnimation = useSelector(selectCurrentAnimation);
  const isAnimationPlaying = curAnimation !== null && typeof curAnimation !== 'undefined';
  const dispatch = useDispatch();

  if (!isMyTurn) {
    if (myPlayer.health > 0) {
      return <button className="button" disabled>
        <span className="button-content-fixed-width"><Trans>WAITING FOR TURN</Trans></span>
      </button>;
    } else {
      return <button className="button" disabled>
        <span className="button-content-fixed-width"><Trans>YOU DIED</Trans></span>
      </button>;
    }
  }

  const rollDiceCb = () => dispatch(rollDice());
  const acceptRollCb = () => dispatch(acceptRoll());
  const endTurnCb = () => !isAnimationPlaying ? dispatch(endTurn()) : null;

  if (rollsLeft || isRolling) {
    const rollText = isRolling ? <Trans>ROLLING</Trans> : <Trans>ROLL DICE</Trans>;
    return <>
      <button
        type="submit"
        className={`button ${isRolling ? 'rolling-dice' : ''} ${hasRolledYet === false ? 'shaking-button' : ''}`}
        id="roll-dice-button"
        onClick={rollDiceCb}
        disabled={isRolling || (hasRolledYet === true && anyDicePicked === false)}
      >
        <span className="count-dice-rolls-left">{rollsLeft}</span>
        <span className="button-content-fixed-width">{rollText}</span>
      </button>

      <button type="submit" className="button" id="lock-dice-button" onClick={rollsLeft ? acceptRollCb : null} disabled={isRolling || hasRolledYet === false}>
        <span className="button-content-fixed-width"><i className="fas fa-check"></i></span>
      </button>
    </>;
  } else {
    return <button type="submit" className={`button ${isAnimationPlaying ? '' : 'shaking-button'}`} id="roll-dice-button" onClick={endTurnCb} disabled={isAnimationPlaying}>
      <span className="button-content-fixed-width"><Trans>END TURN</Trans></span>
    </button>;
  }
}
